export const BASE_URL = "https://nodelogic.up.railway.app"
// export const BASE_URL = "https://mernappbackend.onrender.com"